module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point05_02_sunset-cc42b380201a19f4b50bc770c9bfbdaf.jpg";